import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {RoleGuard} from '../../services/role.guard';
import {SignUpComponent} from './signup/signup.component';
import {LoginComponent} from './login/login.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {UpdatePasswordComponent} from './update-password/update-password.component';
import {AuthGuard} from '../../services/auth.guard';

const route: Routes = [
  {path: 'signup', component: SignUpComponent, canActivate: [AuthGuard]},
  {path: 'login', component: LoginComponent, canActivate: [AuthGuard]},
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'password/reset/:token',
    component: UpdatePasswordComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(route)
  ],
  exports: [
    RouterModule
  ]
})
export class AuthenticationRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/modules/authentication/authentication-routing.module.ts